import { NotificationInstance } from 'antd/es/notification/interface'
import { createContext, useContext } from 'react'

export const NotificationContext = createContext<{
  notification: NotificationInstance
}>(undefined)
NotificationContext.displayName = 'NotificationContext'

export const useNotificationContext = () => useContext(NotificationContext)
